<template>
  <div>
    <el-carousel height="500px">
      <el-carousel-item v-for="item in banners" :key="item">
        <el-image :src="item" class="banner-img" fit="cover" />
      </el-carousel-item>
    </el-carousel>
    <el-row class="line1">
      <el-col class="line-large text-center">
        <h1>产品与服务</h1>
        <el-row :gutter="80">
          <el-col :span="2" class="min-height"></el-col>
          <el-col :span="5">
            <i></i>
            <div class="f18 text-black margin-bottom">电子合同</div>
            <div class="text-gray f14 height">权威第三方电子合同平台，提供在线的电子合同订立、发送、签署、存证、鉴定等服务。</div>
          </el-col>
          <el-col :span="5">
            <i></i>
            <div class="f18 text-black margin-bottom">身份认证</div>
            <div class="text-gray f14 height">公安、银行卡、活体识别实名认证，第三方数字证书签发和续期，支持U盾证书、移动证书和云端证书。</div>
          </el-col>
          <el-col :span="5">
            <i></i>
            <div class="f18 text-black margin-bottom">电子签名/签章</div>
            <div class="text-gray f14 height">专业电子签名/电子签章系统，提供PC签章、移动签章、签名屏签章等丰富功能。</div>
          </el-col>
          <el-col :span="5">
            <i></i>
            <div class="f18 text-black margin-bottom">存证和司法服务</div>
            <div class="text-gray f14 height">提供电子数据第三方存证、司法鉴定、合同公证、电子数据司法诉讼律师服务。</div>
          </el-col>
          <el-col :span="2" class="min-height"></el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      banners: [
        require('@/assets/banner-1.jpg')
      ]
    };
  }
};
</script>

<style scoped>
.banner-img {
  width: 100%;
  height: 100%;
}
.min-height {
  min-height: 20px;
}
.f18 {
  font-size: 18px;
}
.margin-bottom {
  margin-bottom: 10px;
}
.text-gray {
  color: #8a8a8a;
}
.f14 {
  font-size: 14px;
}
.height {
  line-height: 24px;
}
.line1 {
    padding-top: 70px;
    overflow: hidden;
    padding-bottom: 100px;
}
.line1 .line-large {
    margin-left: -35px;
    margin-right: -35px;
}
.text-center {
    text-align: center;
}
.line1 .line-large .el-col i {
  display: block;
  width: 100px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  background: url("../assets/ico_index.png") no-repeat;
  margin-bottom: 30px;
}
.line1 .line-large .el-col:nth-child(1) i {
  background-position: 15px 0;
}
.line1 .line-large .el-col:nth-child(2) i {
  background-position: -298px 0;
}
.line1 .line-large .el-col:nth-child(3) i {
  background-position: -610px 0;
}
.line1 .line-large .el-col:nth-child(4) i {
  background-position: -915px 0;
}
</style>
